import { useTranslation } from "react-i18next";

const POWERED_BY_URL = "https://emeistechnologies.com/";

type AppFooterProps = {
  /** "app" shows copyright + powered by; "auth" shows powered by only (copyright optional via showCopyright). */
  variant?: "app" | "auth";
  showCopyright?: boolean;
  className?: string;
  copyrightClassName?: string;
};

export function PoweredBy({ className = "" }: { className?: string }) {
  const { t } = useTranslation("common");
  return (
    <span className={className}>
      {t("footer.poweredBy")}{" "}
      <a
        href={POWERED_BY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-inherit hover:underline"
      >
        Emeis Technologies
      </a>
    </span>
  );
}

export function AppFooter({
  variant = "app",
  showCopyright = variant === "app",
  className = "",
  copyrightClassName = "",
}: AppFooterProps) {
  const { t } = useTranslation("common");
  const year = new Date().getFullYear();

  return (
    <footer
      className={`w-full border-t border-[rgb(var(--border))] bg-[rgb(var(--card))]/80 backdrop-blur-md px-4 py-1 text-[11px] leading-4 text-[rgb(var(--text-muted))] ${className}`}
    >
      <div className="mx-auto flex w-full max-w-[1600px] flex-col items-center gap-0.5 sm:flex-row sm:justify-between">
        {showCopyright ? (
          <span className={copyrightClassName}>
            {t("footer.copyright", { year })}
          </span>
        ) : (
          <span />
        )}
        <PoweredBy />
      </div>
    </footer>
  );
}
